import { gql } from 'graphql-tag';

// =============================================================================
// Program Automation GraphQL Operations
// Replaces Lambda REST calls to VITE_AUTOMATE_SETUP_SERVICE
// =============================================================================

// --- Queries ---

export const SIMULATE_SCOPE_QUERY = gql`
  query SimulateScope($website: String!) {
    simulateScope(website: $website)
  }
`;

export const SIMULATE_PROGRAM_DETAILS_QUERY = gql`
  query SimulateProgramDetails($website: String!, $scope: String!) {
    simulateProgramDetails(website: $website, scope: $scope) {
      id
      programName
      programDesc
      organizationName
      requiredSkills
      requiredTech
      pathways
      published
      keywords
      adks
    }
  }
`;

export const GENERATE_SCOPE_PROMPT_QUERY = gql`
  query GenerateScopePrompt(
    $websiteUrl: String!
    $careers: String
    $skills: String
    $tools: String
    $user: String
    $strengths: String
    $passions: String
    $problems: String
    $jobs: String
    $goals: String
    $deliverables: String
  ) {
    generateScopePrompt(
      websiteUrl: $websiteUrl
      careers: $careers
      skills: $skills
      tools: $tools
      user: $user
      strengths: $strengths
      passions: $passions
      problems: $problems
      jobs: $jobs
      goals: $goals
      deliverables: $deliverables
    )
  }
`;

export const GENERATE_MULTIPLE_SCOPE_PROMPT_QUERY = gql`
  query GenerateMultipleScopePrompt(
    $websiteUrls: [String!]!
    $careers: String
    $skills: String
    $tools: String
    $user: String
    $strengths: String
    $passions: String
    $problems: String
    $jobs: String
    $goals: String
    $deliverables: String
  ) {
    generateMultipleScopePrompt(
      websiteUrls: $websiteUrls
      careers: $careers
      skills: $skills
      tools: $tools
      user: $user
      strengths: $strengths
      passions: $passions
      problems: $problems
      jobs: $jobs
      goals: $goals
      deliverables: $deliverables
    )
  }
`;

export const GENERATE_TITLE_PROMPT_QUERY = gql`
  query GenerateTitlePrompt($websiteUrl: String!, $scope: String!) {
    generateTitlePrompt(websiteUrl: $websiteUrl, scope: $scope)
  }
`;

export const GET_BULK_SETUP_SCOPES_QUERY = gql`
  query GetBulkSetupScopes($bulkId: String) {
    getBulkSetupScopes(bulkId: $bulkId)
  }
`;

export const OPENAI_CHAT_PROXY_QUERY = gql`
  query OpenAIChatProxy(
    $prompt: String!
    $systemPrompt: String
    $model: String
    $temperature: Float
    $maxTokens: Float
    $requesterId: String
  ) {
    openAIChatProxy(
      prompt: $prompt
      systemPrompt: $systemPrompt
      model: $model
      temperature: $temperature
      maxTokens: $maxTokens
      requesterId: $requesterId
    )
  }
`;

export const TEMPLATE_DISCOVERY_QUERY = gql`
  query TemplateDiscovery {
    templateDiscovery {
      id
      templateName
      templateDesc
      displayIcon
      displayColor
      estimatedDuration
      displayOrder
    }
  }
`;

// --- Mutations ---

export const CREATE_AUTOMATION_PROGRAM_MUTATION = gql`
  mutation CreateAutomationProgram($data: JSONObject!) {
    createAutomationProgram(data: $data) {
      id
      programName
      programDesc
    }
  }
`;

export const CREATE_PROGRAM_BY_TEMPLATE_ID_MUTATION = gql`
  mutation CreateProgramByTemplateId($templateId: String!, $data: JSONObject!) {
    createProgramByTemplateId(templateId: $templateId, data: $data) {
      id
      programName
      programDesc
      slug
      sharable_url
    }
  }
`;

export const UPDATE_AUTOMATION_ADK_MUTATION = gql`
  mutation UpdateAutomationAdk($programId: String!, $adkId: String!, $content: JSONObject!) {
    updateAutomationAdk(programId: $programId, adkId: $adkId, content: $content) {
      id
      programName
    }
  }
`;

export const CREATE_AUTOMATION_ADK_MUTATION = gql`
  mutation CreateAutomationAdk($programId: String!, $adk: JSONObject!) {
    createAutomationAdk(programId: $programId, adk: $adk) {
      id
      programName
    }
  }
`;

export const SAVE_BULK_SETUP_SCOPES_MUTATION = gql`
  mutation SaveBulkSetupScopes($bulkId: String!, $website: String!, $scopes: [String!]!) {
    saveBulkSetupScopes(bulkId: $bulkId, website: $website, scopes: $scopes)
  }
`;
